(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        function positionWishlistPopup(anchorElement) {
            var wishlistPopup = document.querySelector('.wishlist-hotel-popup');

            if (!wishlistPopup) {
                return;
            }

            if (!anchorElement) {
                wishlistPopup.style.left = '50%';
                wishlistPopup.style.top = '120px';
                wishlistPopup.style.transform = 'translate(-50%, -50%)';
                wishlistPopup.style.width = '';
                wishlistPopup.style.right = '';
                wishlistPopup.style.bottom = '';
                return;
            }

            var rect = anchorElement.getBoundingClientRect();
            var popupWidth = Math.min(window.innerWidth - 30, 470);
            var anchorCenter = rect.left + rect.width / 2;
            var leftBound = popupWidth / 2 + 15;
            var rightBound = window.innerWidth - popupWidth / 2 - 15;
            var centeredLeft = Math.min(Math.max(anchorCenter, leftBound), rightBound);

            wishlistPopup.style.width = popupWidth + "px";
            wishlistPopup.style.left = centeredLeft + "px";
            wishlistPopup.style.top = rect.bottom - 110 + "px";
            wishlistPopup.style.transform = 'translateX(-50%)';
            wishlistPopup.style.right = 'auto';
            wishlistPopup.style.bottom = 'auto';
        }

        function showWishlistPopup(isAdded) {
            var anchorElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var wishlistPopup = document.querySelector('.wishlist-hotel-popup');

            // Скрываем все элементы
            wishlistPopup.querySelectorAll('.hotel-wishlist-added, .hotel-wishlist-removed, .great, .done, .emoji').forEach(function (el) {
                el.classList.add('hide');
            });

            // Показываем нужные элементы в зависимости от действия
            if (isAdded) {
                // Отель добавлен в избранное
                wishlistPopup.querySelectorAll('.emoji').forEach(function (el) {
                    el.classList.remove('hide');
                    el.setAttribute('src', '/x-assets/img/emoji/white-heart-in-red-square.svg');
                });
                wishlistPopup.querySelectorAll('.hotel-wishlist-added, .great').forEach(function (el) {
                    el.classList.remove('hide');
                });
            } else {
                // Отель удален из избранного
                wishlistPopup.querySelectorAll('.emoji').forEach(function (el) {
                    el.classList.remove('hide');
                    el.setAttribute('src', '/x-assets/img/emoji/emoji-ok.png');
                });
                wishlistPopup.querySelectorAll('.done, .hotel-wishlist-removed').forEach(function (el) {
                    el.classList.remove('hide');
                });
            }

            positionWishlistPopup(anchorElement);

            // Показываем попап с анимацией
            wishlistPopup.classList.add('ease-show');
            wishlistPopup.classList.remove('hide');

            // Автоматически скрываем через 3 секунды
            setTimeout(function () {
                wishlistPopup.classList.remove('ease-show');
                setTimeout(function () {
                    wishlistPopup.classList.add('hide');
                }, 500);
            }, 3000);
        }

        function showWishlistPopupAfterAuth() {
            var hotelId = sessionStorage.getItem('wishlistAuthSuccessHotelId');

            if (!hotelId) {
                return;
            }

            var target = document.querySelector(".liked-hotel[data-id=\"" + hotelId + "\"]");

            sessionStorage.removeItem('wishlistAuthSuccessHotelId');

            if (!target) {
                return;
            }

            var url = new URL(window.location.href);
            url.searchParams.delete('fromHotelWishlist');
            url.searchParams.delete('hotelId');
            window.history.replaceState({}, '', "" + url.pathname + url.search + url.hash);

            showWishlistPopup(true, target);
        }

        // Метод для отправки аналитики
        function sendWishlistAnalytics(hotelId, action, eventPage) {
            var eventProperties = {
                'HotelId': hotelId,
                'Page': eventPage
            };
            window.brxTracking.sendAnalyticsEvent(action, eventProperties);
        }

        // Метод для добавления анимации пульса
        function addPulseAnimation(target) {
            target.classList.add('pulse-animation');
            setTimeout(function () {
                target.classList.remove('pulse-animation');
            }, 500);
        }

        // Обработчик удаления отеля из избранного
        eventDispatcher.on('click', '.liked-hotel', function (e) {
            var target = e.target.closest('.liked-hotel');
            var hotelId = target.dataset.id;
            var eventPage = target.dataset.page;
            var removeWishlistHotelLink = window.wishlistServiceVars.links.removeWishlistHotel || '/new/wishlist/remove-wishlist-hotel';

            sendWishlistAnalytics(hotelId, 'click_remove_wishlist_hotel', eventPage);
            addPulseAnimation(target);

            var queryString = new URLSearchParams({ hotelId: hotelId }).toString();
            var urlWithParams = removeWishlistHotelLink + "?" + queryString;

            // eslint-disable-next-line no-undef
            ajax.post(urlWithParams, {}, function (data) {
                if (data.success) {
                    target.src = '/x-assets/img/icons/icon-unfilled-heart-blue.svg';
                    target.classList.remove('liked-hotel');
                    target.classList.add('unliked-hotel');
                    showWishlistPopup(false, target); // false = удален из избранного
                } else {
                    // eslint-disable-next-line no-alert
                    alert('К сожалению, не удалось убрать отель из списка избранного, попробуйте позднее');
                }
            });
        });

        // Обработчик добавления отеля в избранное
        eventDispatcher.on('click', '.unliked-hotel', function (e) {
            var target = e.target.closest('.unliked-hotel');
            var hotelId = target.dataset.id;
            var eventPage = target.dataset.page;
            var addWishlistHotelLink = window.wishlistServiceVars.links.addWishlistHotel || '/new/wishlist/add-wishlist-hotel';

            sendWishlistAnalytics(hotelId, 'click_add_wishlist_hotel', eventPage);
            addPulseAnimation(target);

            var queryString = new URLSearchParams({ hotelId: hotelId }).toString();
            var urlWithParams = addWishlistHotelLink + "?" + queryString;

            // eslint-disable-next-line no-undef
            ajax.post(urlWithParams, {}, function (data) {
                if (data.success) {
                    target.src = '/x-assets/img/icons/icon-filled-heart.svg';
                    target.classList.remove('unliked-hotel');
                    target.classList.add('liked-hotel');
                    showWishlistPopup(true, target); // true = добавлен в избранное
                } else {
                    // eslint-disable-next-line no-alert
                    alert('К сожалению, не удалось добавить отель в список избранного, попробуйте позднее');
                }
            });
        });

        // eslint-disable-next-line no-undef
        eventDispatcher.on('click', '.empty-heart', function () {
            window.showPageLoader();
            setTimeout(function () {
                window.hidePageLoader();
            }, 1500);
        });

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function () {
                showWishlistPopupAfterAuth();
            });
        } else {
            showWishlistPopupAfterAuth();
        }
    }, {}] }, {}, [1]);